import React from "react";

import { AUTOPILOT_COLORS } from "../../../../components/autopilot/styles";

// Badge de status do arquivo na fila de recepção (PO1-2717/PO1-2719).
// Cores por token: acompanha tema claro/escuro.
export default function StatusBadge({ status }) {
  const meta = {
    NaFila: { label: "Na fila", color: AUTOPILOT_COLORS.statusInfo },
    Processado: { label: "Processado", color: AUTOPILOT_COLORS.statusSuccess },
    Rejeitado: { label: "Rejeitado", color: AUTOPILOT_COLORS.statusDanger },
  }[status] || { label: status, color: AUTOPILOT_COLORS.muted };

  return (
    <span
      style={{
        padding: "2px 10px",
        borderRadius: 999,
        background: `color-mix(in srgb, ${meta.color} 14%, transparent)`,
        color: meta.color,
        fontSize: "0.7rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        whiteSpace: "nowrap",
      }}
    >
      {meta.label}
    </span>
  );
}
